<template>
  <button :class="buttonType">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "NsBifrostButton",
  props: {
    /**
     * type="hit" will give you a black based button,
     * type="ghost" will give you a ghost based button
     */
    type: {
      type: String,
      default: "hit"
    }
  },
  data() {
    return {
      buttonType: "primary-solid"
    };
  },
  mounted() {
    if (this.type === "ghost") {
      this.buttonType = "primary-ghost";
    } else {
      this.buttonType = "primary-solid";
    }

    this.$el.style.setProperty("--ns-button-gradient-position", "-102%");
    this.$el.addEventListener("mousemove", e => {
      this.$el.style.setProperty(
        "--ns-button-gradient-position",
        ((e.pageX - this.$el.offsetLeft) / this.$el.offsetWidth) * 100 + "%"
      );
    });

    this.$el.addEventListener("mouseleave", e => {
      this.$el.style.setProperty("--ns-button-gradient-position", "-102%");
    });
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";
@use "~@nuskin/ns-core-styles/src/scss/buttons";
@use "~@nuskin/ns-core-styles/src/scss/colors";

button {
  @extend %button-base;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    top: -1px;
    left: calc(var(--ns-button-gradient-position) + 2px);
    width: calc(200% + 4px);
    min-width: 200px;
    height: calc(100% + 2px);
    background: linear-gradient(
        90deg,
        #aa10ff 0%,
        #3023ae 14%,
        #8743d8 40%,
        #53a0fd 66%,
        #68ca87 100%
      )
      rgb(39, 37, 37);
    opacity: 0.4;
    transform: translate(-50%, 0);
    pointer-events: all;
  }

  &.primary-solid {
    &:hover,
    &:active {
      background-color: map.get(colors.$baseColors, blackhole);
    }

    &:active {
      &:before {
        background: linear-gradient(
            90deg,
            #aa10ff 0%,
            #6837c9 14%,
            #8743d8 40%,
            #53a0fd 66%,
            #68ca87 100%
          )
          rgb(39, 37, 37);
      }
    }
  }

  &.primary-ghost {
    &:hover {
      background-color: transparent;
      &:before {
        background: linear-gradient(
          90deg,
          rgba(48, 35, 174, 0.15) 0%,
          rgba(135, 67, 216, 0.15) 28%,
          rgba(83, 160, 253, 0.15) 70%,
          rgba(104, 202, 135, 0.15) 100%
        );
      }
    }
  }
}
</style>
